import React from 'react';

import Popup from '../../../components/Popup/Popup';
import UwmModule from '../../../components/UwmModule/UwmModule';
import MODULE_SRC from '../../../consts/uwm/uwmModuleSrc';
import ModalTypes from '../../../enums/app/modalTypes';
import uwmService from '../../../services/uwmService';
import {hideModalAction} from '../../../state/ducks/modal';
import {dispatch} from '../../../state/store';

const QuickStartGuidePopup = ({deviceType}) => {
    const onModuleLoaded = () => {
        uwmService.postTipsAndTutorialsInitMessage({isQuickStartGuide: true, deviceType, skipFirstStep: true});
        uwmService.postMarketLocaleInitMessage();
    };

    const onBackButtonClick = () => {
        dispatch(hideModalAction(ModalTypes.QUICK_START_GUIDE_POPUP));
    };

    return (
        <Popup allowDisplayWithOtherPopups className='h-full w-full max-w-full p-0'>
            <UwmModule
                onBackButtonClick={onBackButtonClick}
                onModuleLoaded={onModuleLoaded}
                src={MODULE_SRC.TIPS_AND_TUTORIALS}
            />
        </Popup>
    );
};

export default QuickStartGuidePopup;
